import {
  LayoutDashboard, Package, Boxes, ClipboardList, Truck, ArrowLeftRight, Warehouse,
  Users, ScrollText, FolderTree, Tags, Layers, ArrowDownToLine, ListChecks, FilePlus,
  FileEdit, FolderOpen, Download, Key, FileBarChart, Link2, Radio,
} from 'lucide-react';

// Single source of truth for the rail and the header page title.
export const NAV_SECTIONS = [
  {
    title: 'Overview',
    items: [
      { to: '/dashboard/admin', icon: LayoutDashboard, label: 'Dashboard', minRole: 'admin', exactRole: 'admin' },
      { to: '/dashboard/warehouse', icon: LayoutDashboard, label: 'My Dashboard', minRole: 'wh_manager', hideForAdmin: true },
    ],
  },
  {
    title: 'Floor',
    items: [
      { to: '/inventory', icon: Boxes, label: 'Inventory' },
      { to: '/products', icon: Package, label: 'Products', minRole: 'wh_manager' },
      { to: '/product-groups', icon: FolderOpen, label: 'Product Groups', minRole: 'admin' },
      { to: '/picklist', icon: ClipboardList, label: 'Create Picklist' },
      { to: '/stock-inward', icon: ArrowDownToLine, label: 'Stock Inward', minRole: 'wh_manager' },
      { to: '/manage-lists', icon: ListChecks, label: 'Manage Lists', minRole: 'wh_manager' },
      { to: '/intransit', icon: Truck, label: 'In-Transit', minRole: 'wh_manager' },
      { to: '/transactions', icon: ArrowLeftRight, label: 'Transactions', minRole: 'wh_manager' },
    ],
  },
  {
    title: 'Channels',
    minRole: 'admin',
    items: [
      { to: '/channel-mapping', icon: Link2, label: 'Channel Mapping', minRole: 'admin' },
      { to: '/dispatch-sync', icon: Radio, label: 'Dispatch Sync', minRole: 'admin' },
    ],
  },
  {
    title: 'Order Planner',
    minRole: 'admin',
    items: [
      { to: '/reorder-report', icon: FileBarChart, label: 'Reorder Report', minRole: 'admin' },
      { to: '/suppliers', icon: Truck, label: 'Suppliers', minRole: 'admin' },
    ],
  },
  {
    title: 'Catalogue',
    minRole: 'wh_manager',
    items: [
      { to: '/categories', icon: FolderTree, label: 'Categories', minRole: 'admin' },
      { to: '/subcategories', icon: Tags, label: 'Sub Categories', minRole: 'wh_manager' },
      { to: '/bulk-category', icon: Layers, label: 'Bulk Mapping', minRole: 'admin' },
      { to: '/bulk-products', icon: FilePlus, label: 'Bulk Product Creation', minRole: 'admin' },
      { to: '/bulk-inventory', icon: FileEdit, label: 'Bulk Inventory Update', minRole: 'admin' },
      { to: '/export', icon: Download, label: 'Export Data', minRole: 'admin' },
    ],
  },
  {
    title: 'System',
    minRole: 'wh_manager',
    items: [
      { to: '/warehouses', icon: Warehouse, label: 'Warehouses', minRole: 'admin' },
      { to: '/users', icon: Users, label: 'Users', minRole: 'super_admin' },
      { to: '/settings/api-keys', icon: Key, label: 'API Keys', minRole: 'admin' },
      { to: '/logs', icon: ScrollText, label: 'Activity Logs', minRole: 'wh_manager' },
    ],
  },
];

const EXTRA_TITLES = {
  '/products/new': 'New Product',
  '/products/edit': 'Edit Product',
  '/users/new': 'New User',
  '/users/edit': 'Edit User',
  '/product-groups/': 'Product Group',
};

export const titleForPath = (pathname) => {
  for (const section of NAV_SECTIONS) {
    for (const item of section.items) {
      if (item.to === pathname) return item.label;
    }
  }
  const key = Object.keys(EXTRA_TITLES).find((k) => pathname.startsWith(k));
  return key ? EXTRA_TITLES[key] : 'Inventory';
};
